import { axios, base } from '../http';

export const getDingTalkConfig = (params) => {
  return axios.get(`${base}/api/DingDingConfig/get`, { params });
};

export const removeDingTalkConfig = (params) => {
  return axios.delete(`${base}/api/DingDingConfig/delete`, { params });
};

export const batchDeleteDingTalkConfig = (params) => {
  return axios.delete(`${base}/api/DingDingConfig/BatchDelete`, { params });
};

export const addDingTalkConfig = (params) => {
  return axios.post(`${base}/api/DingDingConfig/post`, params);
};

export const updateDingTalkConfig = (params) => {
  return axios.put(`${base}/api/DingDingConfig/put`, params);
};
